import { render, staticRenderFns } from "./SuggestionItem.vue?vue&type=template&id=94fea9d2&"
import script from "./SuggestionItem.vue?vue&type=script&lang=js&"
export * from "./SuggestionItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports